import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { cn, InfoButton } from "@vd/ui";
import { serverQuery } from "../../api/ops";
import { Card, ErrorState, Loading, PageHeader } from "../../components/ui";

export const Route = createFileRoute("/_app/server")({
  staticData: { crumb: { label: "Server", parents: [] } },
  loader: ({ context }) => context.queryClient.prefetchQuery(serverQuery),
  component: ServerPage,
});

function ServerPage() {
  const q = useQuery(serverQuery);
  return (
    <>
      <PageHeader
        title="Server"
        actions={
          <InfoButton kind="help" label="About server settings">
            These live in the server's environment file. Change them over SSH.
          </InfoButton>
        }
      />
      <Card className="max-w-[1040px]">
        {q.isPending ? (
          <Loading />
        ) : q.isError ? (
          <ErrorState error={q.error} onRetry={() => q.refetch()} />
        ) : (
          <ul className="grid gap-x-6 px-4 py-2 md:grid-cols-2">
            {q.data.items.map((s) => (
              <li
                key={s.key}
                className="flex items-center gap-3 border-hairline border-b py-2.5 last:border-b-0 md:[&:nth-last-child(2):nth-child(odd)]:border-b-0"
              >
                <span className="flex min-w-0 flex-1 flex-col">
                  <span className="font-medium text-ink text-ui">{s.label}</span>
                  <span className="truncate text-caption text-ink-3" title={s.note}>
                    {s.note}
                  </span>
                </span>
                <span
                  className={cn(
                    "inline-flex h-6 shrink-0 items-center rounded-pill px-2.5 font-medium text-caption",
                    s.set ? "bg-success-soft text-success" : "bg-fill-2 text-ink-2",
                  )}
                >
                  {s.set ? "Set" : "Missing"}
                </span>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </>
  );
}
